/* Texty sdílených komponent základu (InfoTip, okno, skupiny kalkulaček, Sdílet)
 * v pěti jazycích. Vlastní malý slovník, protože i18n soubory souběžně mění
 * jiné týmy; chybějící překlad → čeština, nikdy holý klíč.
 */
import * as Jazyk from "@/contexts/LanguageContext";

// Mock LanguageContext v testech mívá jen useLanguage → pak ten (vybráno jednou, ne za běhu).
const useJazykZakladu = Jazyk.useLanguageVolitelne || Jazyk.useLanguage;

export const TEXTY_ZAKLADU = Object.freeze({
  cs: {
    napoveda: "Nápověda",
    zavrit: "Zavřít",
    vstupyKlienta: "Vstupy klienta",
    upravit: "Upravit",
    ulozit: "Uložit",
    vratitHodnoty: "Vrátit hodnoty",
    zKlienta: "z klienta",
    nezadano: "nezadáno",
    zalozky: "Záložky skupiny",
    prazdnaSkupina: "Kalkulačky této skupiny se připravují.",
    zpetNaNastroje: "Zpět na Nástroje",
    neznamaSkupina: "Tahle skupina kalkulaček neexistuje.",
    sdilet: "Sdílet",
    odkaz: "Odkaz pro klienta",
    pdf: "Stáhnout PDF",
    tisk: "Tisk",
    pdfChyba: "PDF se teď nepodařilo vytvořit.",
    nacitam: "Načítám…",
    uver: "Úvěr",
    sazba: "Sazba",
    horizont: "Horizont",
    vek: "Věk",
    prijem: "Příjem",
    cil: "Cílová částka",
    vklad: "Měsíční vklad",
    let: "let",
  },
  sk: {
    napoveda: "Nápoveda",
    zavrit: "Zavrieť",
    vstupyKlienta: "Vstupy klienta",
    upravit: "Upraviť",
    ulozit: "Uložiť",
    vratitHodnoty: "Vrátiť hodnoty",
    zKlienta: "z klienta",
    nezadano: "nezadané",
    zalozky: "Záložky skupiny",
    prazdnaSkupina: "Kalkulačky tejto skupiny sa pripravujú.",
    zpetNaNastroje: "Späť na Nástroje",
    neznamaSkupina: "Táto skupina kalkulačiek neexistuje.",
    sdilet: "Zdieľať",
    odkaz: "Odkaz pre klienta",
    pdf: "Stiahnuť PDF",
    tisk: "Tlač",
    pdfChyba: "PDF sa teraz nepodarilo vytvoriť.",
    nacitam: "Načítavam…",
    uver: "Úver",
    sazba: "Sadzba",
    horizont: "Horizont",
    vek: "Vek",
    prijem: "Príjem",
    cil: "Cieľová suma",
    vklad: "Mesačný vklad",
    let: "rokov",
  },
  en: {
    napoveda: "Help",
    zavrit: "Close",
    vstupyKlienta: "Client inputs",
    upravit: "Edit",
    ulozit: "Save",
    vratitHodnoty: "Reset values",
    zKlienta: "from client",
    nezadano: "not entered",
    zalozky: "Group tabs",
    prazdnaSkupina: "Calculators for this group are being prepared.",
    zpetNaNastroje: "Back to Tools",
    neznamaSkupina: "This calculator group does not exist.",
    sdilet: "Share",
    odkaz: "Link for client",
    pdf: "Download PDF",
    tisk: "Print",
    pdfChyba: "The PDF could not be created right now.",
    nacitam: "Loading…",
    uver: "Loan",
    sazba: "Rate",
    horizont: "Horizon",
    vek: "Age",
    prijem: "Income",
    cil: "Target amount",
    vklad: "Monthly deposit",
    let: "years",
  },
  uk: {
    napoveda: "Довідка",
    zavrit: "Закрити",
    vstupyKlienta: "Дані клієнта",
    upravit: "Змінити",
    ulozit: "Зберегти",
    vratitHodnoty: "Повернути значення",
    zKlienta: "з клієнта",
    nezadano: "не вказано",
    zalozky: "Вкладки групи",
    prazdnaSkupina: "Калькулятори цієї групи готуються.",
    zpetNaNastroje: "Назад до інструментів",
    neznamaSkupina: "Такої групи калькуляторів не існує.",
    sdilet: "Поділитися",
    odkaz: "Посилання для клієнта",
    pdf: "Завантажити PDF",
    tisk: "Друк",
    pdfChyba: "Не вдалося створити PDF.",
    nacitam: "Завантаження…",
    uver: "Кредит",
    sazba: "Ставка",
    horizont: "Горизонт",
    vek: "Вік",
    prijem: "Дохід",
    cil: "Цільова сума",
    vklad: "Щомісячний внесок",
    let: "років",
  },
  vi: {
    napoveda: "Trợ giúp",
    zavrit: "Đóng",
    vstupyKlienta: "Dữ liệu khách hàng",
    upravit: "Sửa",
    ulozit: "Lưu",
    vratitHodnoty: "Khôi phục giá trị",
    zKlienta: "từ khách hàng",
    nezadano: "chưa nhập",
    zalozky: "Các thẻ của nhóm",
    prazdnaSkupina: "Các máy tính của nhóm này đang được chuẩn bị.",
    zpetNaNastroje: "Quay lại Công cụ",
    neznamaSkupina: "Nhóm máy tính này không tồn tại.",
    sdilet: "Chia sẻ",
    odkaz: "Liên kết cho khách hàng",
    pdf: "Tải PDF",
    tisk: "In",
    pdfChyba: "Hiện không thể tạo PDF.",
    nacitam: "Đang tải…",
    uver: "Khoản vay",
    sazba: "Lãi suất",
    horizont: "Thời hạn",
    vek: "Tuổi",
    prijem: "Thu nhập",
    cil: "Số tiền mục tiêu",
    vklad: "Gửi hàng tháng",
    let: "năm",
  },
});

/** Text pro jazyk; neznámý jazyk nebo chybějící klíč → čeština. */
export function textZakladu(lang, klic) {
  const slovnik = TEXTY_ZAKLADU[lang] || TEXTY_ZAKLADU.cs;
  return slovnik[klic] ?? TEXTY_ZAKLADU.cs[klic] ?? "";
}

/** Hook: `const tz = useTextZakladu(); tz("zavrit")`. Neznámý jazyk → čeština. */
export function useTextZakladu() {
  // Bez LanguageProvider (izolované testy, vložené tabulky) → čeština, ne pád.
  const jazyk = useJazykZakladu();
  const lang = (jazyk && jazyk.lang) || "cs";
  return (klic) => textZakladu(lang, klic);
}
